import type { FormInstance } from 'antd';
import { Card, Form, Tag, Tree } from 'antd';
import { DataNode } from 'antd/es/tree';
import React, { Key } from 'react';
import { TagInterface } from 'type/tagType';

export const TagRule: React.FC<{
  tags: TagInterface[];
  form: FormInstance;
}> = ({ tags, form }) => {
  const checkedKeys = Form.useWatch('tag', form) || [];
  const [expandedKeys, setExpandedKeys] = React.useState<React.Key[]>([]);
  const treeData: DataNode[] = [
    {
      title: 'all',
      key: 0,
      children: tags.map(tag => ({
        title: tag.name,
        key: tag.id,
        isLeaf: true,
      })),
    },
  ];

  const handleTagSelect = (checkedKeys: Key[] | { checked: Key[]; halfChecked: Key[] }): void => {
    const keys = Array.isArray(checkedKeys) ? checkedKeys : checkedKeys.checked;
    if (keys.includes(0)) {
      const newRules = [0];

      form.setFields([
        {
          name: 'tag',
          value: newRules,
        },
      ]);
    } else {
      const newRules = keys.map(key => Number(key));
      form.setFields([
        {
          name: 'tag',
          value: newRules,
        },
      ]);
    }
  };

  return (
    <div>
      <h3 style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <span>Tags</span>
        <span
          style={{
            flex: 1,
            borderBottom: '1px solid #666',
            marginLeft: '8px',
            height: '0.5em',
          }}
        />
      </h3>
      <Card style={{ marginBottom: '10px', border: '1px solid #ccc' }}>
        {checkedKeys.map((key: string, index: number) => (
          <Tag
            key={index}
            closable
            onClose={() => {
              const newRules = checkedKeys.filter((r: { value: string }) => r.value !== key);
              form.setFields([
                {
                  name: 'tag',
                  value: newRules,
                },
              ]);
            }}
          >
            {Number(key) === 0 ? 'All' : tags.find(tag => tag.id === Number(key))?.name}
          </Tag>
        ))}
      </Card>
      <Form.Item name="tag" noStyle>
        <Tree
          checkable
          checkedKeys={checkedKeys}
          treeData={treeData}
          onCheck={handleTagSelect}
          expandedKeys={expandedKeys}
          onExpand={keys => setExpandedKeys(keys)}
          selectable={false}
          defaultExpandAll
          style={{ width: '100%' }}
        />
      </Form.Item>
    </div>
  );
};
